import { Assignment } from 'shared/api/assignment-service';
import { TaughtLesson } from 'shared/api/class-stats';
import { dateService } from 'shared/lib/date';

import { getSortingDateField } from './general';

export const sortStreamDataByStartDateDesc = (
  assignments: Assignment[] | null | undefined,
  lessons: TaughtLesson[] | null | undefined,
) => {
  if (!assignments && !lessons) return null;

  const updated = [...(assignments ?? []), ...(lessons ?? [])];

  updated.sort((a, b) => {
    const aDate = getSortingDateField(a);
    const bDate = getSortingDateField(b);

    return dateService.getDiff(bDate, aDate);
  });

  return updated;
};
